import React from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'

import { Button, Popup } from 'semantic-ui-react'

import './circular-button.css'


const propTypes = {
  popup: PropTypes.oneOfType([PropTypes.element, PropTypes.string]).isRequired,
  // popup: PropTypes.object.isRequired,
  popupPos: PropTypes.string,
  icon: PropTypes.string.isRequired,
  color: PropTypes.string,
  onClick: PropTypes.func,
  onMouseEnter: PropTypes.func,
  style: PropTypes.object,
  link: PropTypes.string,
  size: PropTypes.string,
  hoverable: PropTypes.bool,
}

const defaultProps = {
  popupPos: 'bottom center',
  color: null,
  onClick: null,
  style: null,
  link: null,
  size: null,
  onMouseEnter: null,
  hoverable: false,
}

const MapCircularButton = ({
  popup,
  popupPos,
  color,
  icon,
  onClick,
  style,
  link,
  size,
  onMouseEnter,
  hoverable,
}) => (
  <div className="circularButtonContainer">
    <Popup
      trigger={(
        <Button
          className="circularButton"
          as={link ? Link : null}
          to={link || null}
          color={color}
          circular
          icon={icon}
          size={size || 'large'}
          onClick={onClick}
          style={style || null}
        />
      )}
      style={{ opacity: 0.8 }}
      content={popup}
      onOpen={onMouseEnter || null}
      position={popupPos}
      size='tiny'
      inverted
      hoverable={hoverable}
      flowing
    />
  </div>
)

MapCircularButton.propTypes = propTypes
MapCircularButton.defaultProps = defaultProps

export default MapCircularButton
